export const translations: Record<string, string> = {
  // property types
  residental: 'Жилая',
  commercial: 'Коммерческая',
  suburban: 'Загородная',

  // property subtypes
  secondary_flat: 'Квартира (вторичка)',
  room: 'Комната',
  apartment: 'Апартаменты',
  new_flat: 'Квартира (новостройка)',
  street_retail: 'Стрит ритейл',
  detached_building: 'Отдельно стоящее здание',
  // coworking: 'Коворкинг', // commented due to task 231
  shopping_area: 'Торговая площадь',
  office: 'Офис',
  catering: 'Общепит',
  production: 'Производство',
  business_center: 'Бизнес-центр',
  shopping_center: 'Торговый центр',
  car_service: 'Автосервис',
  warehouse: 'Склад',
  free_appointment: 'Свободное назначение',
  land_plot: 'Земельный участок',
  cottage: 'Коттедж',
  townhouse: 'Таунхаус',
  country_house: 'Дача',
  commercial_land_plot: 'Земельный участок промышленного назначения',

  clientStatus0: 'Новый',
  clientStatus10: 'В работе',
  clientStatus20: 'Сделка закрыта. Ожидание комиссии',
  clientStatus30: 'Сделка закрыта. Комиссия выплачена',
  clientStatus40: 'Удалён',
};

export const objectTransactionTypeTranslations: Record<string, string> = {
  purchase: 'Продажа',
  rent: 'Сдача в аренду',
};

export const clientTransactionTypeTranslations: Record<string, string> = {
  purchase: 'Покупка/продажа',
  rent: 'Аренда',
};
